module.exports = __webpack_public_path__ + "assets/normal/images/NavClose.34ecf68d.png";